import React from 'react';
import { Layout } from './Layout';
import Alert from '@cloudscape-design/components/alert';

export const ErrorPage: React.FC = () => {
    return (
        <Layout breadcrumbs={[
            {
                text: 'Error',
                href: '#'
            }
        ]}>
            <Alert
                statusIconAriaLabel="Error"
                type="error"
                header="Page not found"
            >
                The page you are looking for cannot be found. Please contact system Administrator.
            </Alert>
        </Layout>
    )
}